import { IConfig } from '@cian/config/shared';

export const getSuburbanRKTitle = (config: IConfig, section: string) => {
  const suburbanRKTitle = config.get<string>('suburbanRK.title');

  return suburbanRKTitle && ['sale', 'index', 'rent'].includes(section) ? suburbanRKTitle : undefined;
};
